import { sharedLocalization } from 'controls/designer/features/widgets/localization';

export const i18n: (...keys: (string | number)[]) => string =
	require('core/localization/localization').translator(
		{
			'Global Timebar': { no: 'Global Tidsvelger' },
			'Time zone': { no: 'Tidssone' },
			'Time period': { no: 'Tidsperiode' },
			'Widget already exists on dashboard': { no: 'Widgeten finnes allerede pÃ¥ dashbordet' },
		},
		sharedLocalization,
	);
